<div class="d-flex align-center justify-end">
  <mat-paginator [pageSizeOptions]="[25, 50, 100]" [length]="total()" aria-label="Select page" [pageIndex]="index()" style="background: none" (page)="changePage($event)"></mat-paginator>
  <div class="custom-icon-input-container">
    <input
      #pageSelector
      (blur)="setPage(pageSelector.value)"
      (keydown.enter)="setPage(pageSelector.value)"
      style="width: 50px"
      type="text"
    >
  </div>
</div>
